// Feedback link shown in the Customer Support dialog (NPP-1804).
// Configured via REACT_APP_FEEDBACK_URL in the .env.* files (inlined at build time).

const DEFAULT_FEEDBACK_URL = "https://www.rehrigpacific.com/product-feedback";

const isHttpUrl = (value) => {
  if (typeof value !== "string") return false;
  try {
    const { protocol } = new URL(value);
    return protocol === "https:" || protocol === "http:";
  } catch (e) {
    return false;
  }
};

// Falls back to the default when the variable is missing or is not an
// http(s) URL (e.g. blocks "javascript:" URLs from a mis-edited config).
export const getFeedbackUrl = () => {
  const configured = process.env.REACT_APP_FEEDBACK_URL;
  return isHttpUrl(configured) ? configured : DEFAULT_FEEDBACK_URL;
};
